import { createUseStyles } from "react-jss";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const useStyles = createUseStyles(() => ({
  default: {
    flex: "1",
    paddingRight: "20px",
    "&:last-child": {
      padding: 0,
    },
  },
  popClass: {
    zIndex: "9999 !important",
  },
}));
